<app-modal *ngIf="vo$ | async; let vo" class="app-depot-entity-modal" (triggerClose)="close()">
	<ng-container modal-body>
			<!--     Metadata Entity  -->
			<div  class="app-card-outline__metadata">
					<app-deprec-outline>
							<div
									card-outline-title
									i18n="@@depot.modal.entity.metadata">
									Metadata
							</div>
							<div card-outline-content>
									<app-metadata
											[metadata]="metadata"
											(notifyOnError)="onMetadataError($event)">
													<app-tag-configurator
															configMode="ActiveEdit"
															[availableTags]="vo.availableTags | toArray"
															></app-tag-configurator>
									</app-metadata>
							</div>
					</app-deprec-outline>
			</div>

			 <!--     headers & types  -->
			<app-panel
					class="app-card-outline__headers"
					headerHeight="3rem"
					initialState="true"
					isAlwaysOpen="true"
					[itemsCount]="vo.headersForSelectRepo.elements.size"
					[hasSearchableGrid]="false">
					<span panel-title i18n="@@depot.modal.entity.columns">
						 depot-header-to-charac-entity-mapping
					</span>
					<span panel-info>
						<ng-container
						*ngIf="vo.listErrors.size > 0">
							<div class="selected-columns-alert error" *ngIf="vo.listErrors.has(HeaderErrorKey.NoHeaderSelected)">
								<mat-icon [svgIcon]="DcIcons.Warning"></mat-icon>
								<span i18n="@@general.errors.minOneSelected">
									min one selected column
								</span>
							</div>
						</ng-container>
					</span>
					<dx-data-grid
							keyExpr="id"
							[elementAttr]="{
									id: 'depot-entity-column-config',
									class: 'app-depot-entity-column-config'
							}"
							[repaintChangesOnly]="true"
							[dataSource]="vo.headersForSelectRepo.elements | toArray"
							[hoverStateEnabled]="true"
							[showColumnHeaders]="true"
							[allowColumnResizing]="true"
							[columnAutoWidth]="false"
							[showRowLines]="false"
							[showColumnLines]="false"
							[rowAlternationEnabled]="false"
							[showBorders]="false"
							[selection]="{ mode: 'none' }"
							[width]="'100%'"
							(onContentReady)="onGridContentReady()">
							<dxo-selection
									mode="multiple"
									[showCheckBoxesMode]="'always'"></dxo-selection>

							<dxo-row-dragging
									[allowReordering]="vo.contentReady"
									[onReorder]="onReorder"
									[showDragIcons]="true"
								></dxo-row-dragging>

							<dxo-scrolling mode="virtual"></dxo-scrolling>
							<!-- Fixable in position columns	-->
							<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

							<dxo-load-panel
									shadingColor="rgba(0,0,0,0)"
									[indicatorSrc]="DcLoaders.LoaderInfinite"
									[height]="100"
									[width]="100"
									[enabled]="vo.isFirstLoad"
									[showIndicator]="true"
									[showPane]="true"
									[shading]="true"></dxo-load-panel>

							<ng-container
									*ngFor="let col of vo.headersForSelectRepo.availableColumns | toArray">
									<dxi-column
											*ngIf="col.field === 'position'"
											[dataField]="col.field"
											[caption]="col.alias"
											[groupIndex]="col.groupIdx"
											[visibleIndex]="col.visibleIndex"
											[fixed]="false"
											[allowResizing]="true"
											[allowHiding]="true"
											[allowGrouping]="true"
											[allowSearch]="true"
											[allowFiltering]="col.isSearchable"
											[allowSorting]="true"
											[format]="col.format"
											[alignment]="'left'"
											[allowEditing]="true"
											[visible]="col.visible"></dxi-column>

									<dxi-column
											*ngIf="col.field === 'headerType'"
											[dataField]="col.field"
											[caption]="col.alias"
											[groupIndex]="col.groupIdx"
											[visibleIndex]="col.visibleIndex"
											[fixed]="false"
											[allowResizing]="true"
											[allowHiding]="true"
											[allowGrouping]="true"
											[allowSearch]="col.isSearchable"
											[allowSorting]="true"
											[alignment]="'left'"
											[allowEditing]="false"
											[width]="col.width"
											cellTemplate="headerTypeTemplate"></dxi-column>

									<dxi-column
											*ngIf="col.field === 'header'"
											[dataField]="col.field"
											[caption]="col.alias"
											[groupIndex]="col.groupIdx"
											[visibleIndex]="col.visibleIndex"
											[fixed]="false"
											[allowResizing]="true"
											[allowHiding]="true"
											[allowGrouping]="true"
											[allowSearch]="col.isSearchable"
											[allowSorting]="true"
											[alignment]="'left'"
											[allowEditing]="false"
						[width]="col.width"></dxi-column>

									<dxi-column
											*ngIf="col.field === 'isSelected'"
											[dataField]="col.field"
											[caption]="col.alias"
											[groupIndex]="col.groupIdx"
											[visibleIndex]="col.visibleIndex"
											[fixed]="false"
											[allowResizing]="true"
											[allowHiding]="true"
											[allowGrouping]="true"
											[allowSearch]="col.isSearchable"
											[allowSorting]="true"
											[alignment]="'left'"
											[allowEditing]="false"
											[visible]="col.visible"
											[width]="col.width"
											headerCellTemplate="selectHeaderTemplate"
											cellTemplate="selectedTemplate"></dxi-column>

									<dxi-column
											*ngIf="col.field === 'label'"
											[dataField]="col.field"
											[caption]="col.alias"
											[groupIndex]="col.groupIdx"
											[visibleIndex]="col.visibleIndex"
											[fixed]="false"
											[allowResizing]="true"
											[allowHiding]="true"
											[allowGrouping]="true"
											[allowSearch]="true"
											[allowFiltering]="col.isSearchable"
											[allowSorting]="true"
											[alignment]="'left'"
											[allowEditing]="true"
											[visible]="col.visible"
											[width]="col.width"
											cellTemplate="labelTemplate"></dxi-column>

									<dxi-column
											*ngIf="col.field === 'columnType'"
											[dataField]="col.field"
											[caption]="col.alias"
											[groupIndex]="col.groupIdx"
											[visibleIndex]="col.visibleIndex"
											[fixed]="false"
											[allowResizing]="true"
											[allowHiding]="true"
											[allowGrouping]="true"
											[allowSearch]="col.isSearchable"
											[allowSorting]="true"
											[alignment]="'left'"
											[allowEditing]="false"
											[width]="col.width"
											cellTemplate="columnTypeTemplate"></dxi-column>

									<dxi-column
											*ngIf="col.field === 'format'"
											[dataField]="col.field"
											[caption]="col.alias"
											[groupIndex]="col.groupIdx"
											[visibleIndex]="col.visibleIndex"
											[fixed]="false"
											[allowResizing]="true"
											[allowHiding]="true"
											[allowGrouping]="true"
											[allowSearch]="col.isSearchable"
											[allowSorting]="true"
											[alignment]="'left'"
											[allowEditing]="false"
											[width]="col.width"
											cellTemplate="formatTemplate"></dxi-column>

							</ng-container>

							<div *dxTemplate="let cell of 'labelTemplate'">
									<dx-text-box
											[disabled]="!cell.data['isSelected']"
											[value]="cell.data['label']"
									>
										<dx-validator (onValidated)="onUpdateLabel(cell.key, $event)">
												<dxi-validation-rule
														type="stringLength"
														[min]="1"
														message="this field is required!"
														i18n-message="@@general.form.errors.required"></dxi-validation-rule>
										</dx-validator>
									</dx-text-box>

							</div>

							<div *dxTemplate="let cell of 'columnTypeTemplate'">
								<!--			All other depot headers						-->
									<dx-select-box *ngIf="!cell.data['depotDetails']"
										[disabled]="!cell.data['isSelected'] || cell.data['isList']"
										[dataSource]="cell.data['headerType'] | toCompatibleTypeMapping"
										valueExpr="value"
										displayExpr="label"
										[value]="cell.data['columnType']"
										(onValueChanged)="onSelectColumnType(cell.key, $event)"
										[dropDownOptions]="dropDownOptions"></dx-select-box>

									<!--			Depot Details header						-->
									<dx-select-box *ngIf="cell.data['depotDetails']"
										 [disabled]="true"
										 [dataSource]="cell.data['headerType'] | toCompatibleTypeMapping"
										 valueExpr="value"
										 displayExpr="label"
										 [value]="cell.data['columnType']"
										 (onValueChanged)="onSelectColumnType(cell.key, $event)"
										 [dropDownOptions]="dropDownOptions"></dx-select-box>
							</div>

						<div *dxTemplate="let cell of 'isListTemplate'">
							<mat-slide-toggle
								*ngIf="cell.data['columnType'] === ColumnType.Str"
								id="{{ cmpId }}-{{ cell.rowIndex }}-list-toggle"
								color="primary"
								[disabled]="cell.data['depotDetails']"
								[checked]="cell.data['isList']"
								(change)="
									updateIsList(cell.key, $event.checked)
								"></mat-slide-toggle>
						</div>

						<div *dxTemplate="let cell of 'selectedTemplate'">
							<mat-slide-toggle
								id="{{ cmpId }}-{{ cell.rowIndex }}-selected-toggle"
								color="primary"
								[checked]="cell.data['isSelected']"
								(change)="
								updateIsSelected(cell.key, $event.checked)
							"></mat-slide-toggle>
						</div>

						<div *dxTemplate="let cell of 'selectHeaderTemplate'"
							(mouseenter)="hideAllSelectToggle = true" (mouseleave)="hideAllSelectToggle = false">
							<div [hidden]="hideAllSelectToggle">
								<span i18n="@@depot.modal.entity.columns.column.selectable">Select</span>
							</div>
							<div [hidden]="!hideAllSelectToggle" (click)="toggleAllTriggered($event)">
								<mat-slide-toggle
									id="{{ cmpId }}-{{ cell.rowIndex }}-select-all-toggle"
									color="primary"
									[checked]="!vo.headersForSelectRepo.hasNoSelection"
									(change)="toggleSelectAllRows($event.checked)"></mat-slide-toggle>
							</div>
						</div>

						<div *dxTemplate="let cell of 'formatTemplate'">
							<div
								class="depot-entity-date-format"
								*ngIf="(cell.data['columnType'] === ColumnType.Date && (
								cell.data['headerType'] === ColumnType.Str)) ||
								(cell.data['columnType'] === ColumnType.Str && (
								cell.data['headerType'] === ColumnType.Date))">
								<dx-select-box
									 valueExpr="value"
									 displayExpr="label"
									 [dataSource]="vo.availableDateFormats | toArray"
									 [searchEnabled]="true"
									 [disabled]="!cell.data['isSelected']"
									 (onValueChanged)="onSelectFormat(cell.key, $event)"
									 [value]="cell.data['format']"
									 [dropDownOptions]="dropDownOptions"></dx-select-box>

								<dx-select-box
									placeholder="select-timezone"
									i18n-placeholder="@@depot.modal.entity.select.timezone"
									[dataSource]="vo.availableTimezones"
									[value]="cell.data['timezone']"
									[disabled]="!cell.data['isSelected']"
									[searchEnabled]="true"
									(onValueChanged)="selectTimezone(cell.key, $event)"></dx-select-box>

								<dx-select-box
									placeholder="select-language"
									valueExpr="key"
									displayExpr="label"
									i18n-placeholder="@@depot.modal.entity.select.language"
									[dataSource]="vo.supportedLanguages | toArray"
									[value]="cell.data['language']"
									[searchEnabled]="true"
									[disabled]="!cell.data['isSelected']"
									(onValueChanged)="selectLanguage(cell.key, $event)"></dx-select-box>
							</div>

							<dx-select-box
								*ngIf="(cell.data['columnType'] === ColumnType.Str && cell.data['headerType'] === ColumnType.Dec) ||
								 (cell.data['columnType'] === ColumnType.Dec && cell.data['headerType'] === ColumnType.Str)"
								placeholder="select-number-format"
								i18n-placeholder="@@depot.modal.entity.select.number.format"
								valueExpr="code"
								displayExpr="lib"
								[dataSource]="AvailableNumberFormats"
								[value]="cell.data['format']"
								[disabled]="!cell.data['isSelected']"
								(onValueChanged)="onSelectFormat(cell.key, $event)"></dx-select-box>

						</div>

						<div *dxTemplate="let cell of 'headerTypeTemplate'">
								<app-column-type
										[type]="cell.data['headerType']"
										[isList]="cell.data['isList']"></app-column-type>
						</div>

						<dxo-group-panel [visible]="false"></dxo-group-panel>

						<!-- Search input -->
						<dxo-search-panel [visible]="false"></dxo-search-panel>

						<!-- Sorting	-->
						<dxo-sorting mode="single"></dxo-sorting>

						<!-- Pagination -->
						<dxo-paging [pageSize]="1000"></dxo-paging>

						<dxo-pager [visible]="false"></dxo-pager>
						<!-- State persistence	-->
						<dxo-state-storing
								type="localStorage"
								[enabled]="false"
								[storageKey]="dxLocalStorageKey"></dxo-state-storing>
					</dx-data-grid>
			</app-panel>
</ng-container>

	<div modal-footer class="app-depot-entity-modal__footer">
		<button
				id="{{ cmpId }}-create-btn"
				class="app-depot-entity-modal__footer__btn"
				[color]="'primary'"
				[disabled]="vo.isSaveDisabled || vo.isLoading"
				(click)="onSave()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Save"></mat-icon>
				<span i18n="@@general.action.save">Create</span>
		</button>
	</div>
</app-modal>
